import { render, staticRenderFns } from "./wxMessage.vue?vue&type=template&id=5deb7607&scoped=true"
import script from "./wxMessage.vue?vue&type=script&lang=js"
export * from "./wxMessage.vue?vue&type=script&lang=js"
import style0 from "./wxMessage.vue?vue&type=style&index=0&id=5deb7607&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5deb7607",
  null
  
)

export default component.exports